// extracted by mini-css-extract-plugin
export default {"root":"AdminAgencyAccessPage_root__QDZtI","with-panel":"AdminAgencyAccessPage_with-panel__ivBFA"};